import React from "react";
import "./contact.css";
import { IoLogoWhatsapp } from "react-icons/io";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Loader from "../global/Loader";
import axios from "axios";

const Contact = () => {
  const validationSchema = Yup.object({
    fullName: Yup.string()
      .required("Full name is required")
      .min(3, "Full name must be at least 3 characters"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    phone: Yup.string()
      .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits")
      .required("Phone number is required"),
    message: Yup.string()
      .required("Message is required")
      .min(10, "Message must be at least 10 characters"),
  });

  const handleSubmit = (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);
    const finalValues = JSON.stringify(values);
    console.log("Final Values:", finalValues); // Log the values

    axios
      .post(
        "http://127.0.0.1:5001/bookhr-7756b/us-central1/api/forms/contactform",
        finalValues,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        resetForm();
      })
      .catch((error) => {
        console.error(
          "There was an error submitting the form:",
          error.response?.data || error.message
        );
        // Optionally handle error UI here (e.g., display an error message)
      })
      .finally(() => {
        setSubmitting(false); // Stop the loader
      });
  };

  return (
    <div className="maindiv contact">
      <h2>We’re Here to Help!</h2>
      <p className="contactp">
        At Bhookr, your satisfaction comes first! For questions, subscription
        help, or feedback, our friendly support team is here for you.
      </p>

      <div>
        <Formik
          initialValues={{ fullName: "", email: "", phone: "", message: "" }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form className="formconatct">
              {/* Full Name Field */}
              <div>
                <label htmlFor="fullName">Full Name</label>
                <Field
                  type="text"
                  name="fullName"
                  placeholder="Type here..."
                  className="textfeildcontact"
                />
                <ErrorMessage
                  name="fullName"
                  component="div"
                  className="error"
                />
              </div>

              {/* Email Field */}
              <div>
                <label htmlFor="email">Email</label>
                <Field
                  type="email"
                  name="email"
                  placeholder="Type here..."
                  className="textfeildcontact"
                />
                <ErrorMessage name="email" component="div" className="error" />
              </div>

              {/* Phone Number Field */}
              <div>
                <label htmlFor="phone">Phone Number</label>
                <Field
                  type="text"
                  name="phone"
                  placeholder="Type here..."
                  className="textfeildcontact"
                />
                <ErrorMessage name="phone" component="div" className="error" />
              </div>

              {/* Message Field (Textarea) */}
              <div>
                <label htmlFor="message">Message</label>
                <Field
                  as="textarea"
                  name="message"
                  placeholder="Type here..."
                  className="textfeildcontact textarea"
                />
                <ErrorMessage
                  name="message"
                  component="div"
                  className="error"
                />
              </div>
              <div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="conactsubmit"
                >
                  {isSubmitting ? <Loader /> : "Send us a Message"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className="locationdiv">
        <iframe
          className="loactioncontact"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1904.012821018187!2d78.5529839530742!3d17.36249910339282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99fe7d5ee071%3A0x76eaa3a1811a765e!2sBhookr%20Cloud%20Kitchen!5e0!3m2!1sen!2sin!4v1730269633356!5m2!1sen!2sin"
          width="100%"
          height="600"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Bhookr Cloud Kitchen"
        ></iframe>
      </div>
    </div>
  );
};

export default Contact;
